import { render, staticRenderFns } from "./ProductBar.vue?vue&type=template&id=8e192d66"
import script from "./ProductBar.vue?vue&type=script&lang=js"
export * from "./ProductBar.vue?vue&type=script&lang=js"
import style0 from "./ProductBar.vue?vue&type=style&index=0&id=8e192d66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports